import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import Api from "../api/Api";
import {IResult, IUserProfile} from "../types/api";
import {MUTATION_KEYS, QUERY_KEYS} from "./queryKeys";

export default function useUpdateUserProfileMutation(): UseMutationResult<void | IResult<string | unknown>, Error, IUserProfile, unknown> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.user.updateUserProfile],
    mutationFn: async (values: IUserProfile): Promise<void | IResult<string | unknown>> => {
      return await Api.auth.updateUserProfile(values);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.user.getUserProfile]});
    }
  })
}
